<template>
  <div class="input-col-10-padding position-relative">
      <vue-google-autocomplete
          class="custom-route-input"
          classname="form-control"
          country="lt"
          types=""

          :ref="'address' + id"
          :placeholder="placeHolder"
          :id="'map' + id"

          @inputChange="getChange"
          @placechanged="getAddressData"
      >
      </vue-google-autocomplete>

<!-- TODO maybe refactor this place -->

      <div class="position-absolute d-flex align-items-center" :class="{'icon-x-position': arrivalTime, 'icon-xx-position': !arrivalTime}">

        <template v-if="index">
          <CustomRouteTimePickerComponent :arrival-time="arrivalTime" @getCustomArrivalTime="getArrivalTime"></CustomRouteTimePickerComponent>
        </template>

        <template v-if="!index">
          <div class="customRouteTimePickerComponentContent">
            <div class="input-time-position" v-if="arrivalTime">
              {{ arrivalTime.split(':')[0].trim() + ':' + arrivalTime.split(':')[1].trim() }}
            </div>
          </div>
        </template>


        <div v-if="isRemovable">
          <img @click="$emit('deleteRoute', id)" src="/assets/images/x-times.svg" alt="delete route" srcset="">
        </div>
      </div>

  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import type {PropType} from "vue";
import './customRouteAddressSelect.scss';
// @ts-ignore
import VueGoogleAutocomplete from "../../../js/plugins/vue-google-autocomplete/src/VueGoogleAutocomplete.vue";
// @ts-ignore
import type {ICustomRoute} from '../../store/states/IOrderTrueDriverState.interface';
// @ts-ignore
import CustomRouteTimePickerComponent from "../customRouteTimePicker/CustomRouteTimePickerComponent.vue";
import type {ILocationStore} from "@/store/states/ILocationStoreState.interface";

export default defineComponent({
  components: {
    CustomRouteTimePickerComponent,
    VueGoogleAutocomplete,
  },
  props: {
    placeHolder: {
      type: String,
      required: true
    },
    pickupAddress: {
      type: Boolean
    },
    locationStore: {
      type: Object as PropType<ICustomRoute>,
      default: null
    },
    id: [Number,String],
    arrivalTime: {
      type: String
    },
    isRemovable: {
      type: Boolean
    },
    index: {
      type: Boolean
    }
  },
  emits: ['getAddresses', 'deleteRoute', 'getArrivalTime'],
  data: function () {
    return {
      address: <ILocationStore>{},
    };
  },

  mounted() {
    this.displayAddress(this.locationStore);
  },

  watch: {
    locationStore(newAddress, oldAddress) {
      this.displayAddress(newAddress);
    },
  },

  methods: {
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function (addressData: any, placeResultData: any, id: string): void {
      this.address = <ILocationStore>{...addressData,
        country:"LT",
        formatted_address: placeResultData.formatted_address,
        place_id: placeResultData.place_id,
        url: placeResultData.url
      };
      this.$emit('getAddresses', {value: this.address, pickup: this.pickupAddress, id: this.id});
    },

    setFocus: function (): void {
      (this.$refs['address' + this.id] as HTMLElement).focus();
    },

    displayAddress: function (payload: ILocationStore): string {
      if (!payload) {
        // @ts-ignore
        return (this.$refs['address' + this.id] as HTMLElement).autocompleteText = "";
      }

      let str = '';

      // @ts-ignore
      if (payload.raw) {
        // @ts-ignore
        const raw = payload.raw;

        str += raw.formatted_address;

        if (raw.formatted_address.indexOf(raw.name) < 0) {
          str = raw.name + ', ' + str;
        }
      }

      // @ts-ignore
      return (this.$refs['address' + this.id] as HTMLElement).autocompleteText = str;
    },

    getChange: function (): void {
      //@ts-ignore
      if (this.$refs['address' + this.id].autocompleteText.length === 0) {
        this.$emit('getAddresses', {value: null, pickup: this.pickupAddress, id: this.id});
      }
    },

    getArrivalTime(payload: {value: string}): void {
      this.$emit('getArrivalTime', {value: payload.value});
    }
  },
});
</script>